<template>
  <DetailsLoader
    v-if="!lesson.hasApiData"
    :rows="1"
  />

  <p  
    v-if="lesson.hasApiData" 
    class="text-blue-600 font-semibold text-3xl flex gap-2.5 items-center"
  >
    <SvgIcon
      aria-hidden="true"
      icon-name="signs-post"
      class="shrink-0"
      width="20"
      height="20"
    />
    {{ lesson.path.title }}
  </p>
</template>

<script lang="ts">
export default { name: 'PathTitle' }
</script>

<script setup lang="ts">
import { computed } from 'vue'
import { useExternalContent } from '~/composables/useExternalContent'

import { LessonRecord } from '~/types/records/LessonRecord'

import DetailsLoader from '~/components/loaders/DetailsLoader.vue'

const props = defineProps<{
  lessonEnc: string,
}>()

const {
  algoliaRecord,
  apiRecord,
  hasApiData,
} = useExternalContent(props.lessonEnc)

// merge all the data for use in the template
const lesson = computed(() => {
  return {
    ...algoliaRecord,
    ...apiRecord.value,
    hasApiData,
  } as LessonRecord
})
</script>
